import React from "react";
import { Link } from "react-router-dom";

const ConBanner = () => {
  return (
    <>
      <div className="row gx-0">
        <div
          className="col-md-10 text-center p-md-5 pt-3 pb-4 m-auto border"
          style={{
            borderRadius: "15px",
            backgroundColor: "rgb(37,43,58)",
            color: "white",
          }}
        >
          <h5 className="fw-normal"> Get In Touch </h5>
          <h1 className="px-md-5">
            Let's have an awesome experience together from start to finish
          </h1>
          <div className="pt-4">
            <Link to={"/contact"} className="navBtnLinks">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
      <div className="mx-5 px-5 pt-5 text-muted d-none d-md-flex" style={{justifyContent:"space-between"}}>
          <div> © 2022. All rigths reserved </div>
          <div> Designed by Vinay Singh</div>
      </div>
    </>
  );
};

export default ConBanner;
